/**
 * Dados do Chatbot de Suporte e Tutoriais
 * Respostas pré-definidas para perguntas frequentes e guias passo a passo
 */

// ============================================================
// CATEGORIAS DO CHATBOT
// ============================================================
export const chatCategories = [
  {
    id: 'owner',
    label: '💈 Sou Barbeiro/Dono',
    icon: 'scissors',
    description: 'Ajuda para donos de barbearia',
  },
  {
    id: 'client',
    label: '👤 Sou Cliente',
    icon: 'user',
    description: 'Ajuda para clientes',
  },
  {
    id: 'account',
    label: '🔐 Conta e Acesso',
    icon: 'settings',
    description: 'Login, registo e perfil',
  },
  {
    id: 'general',
    label: '❓ Geral',
    icon: 'info',
    description: 'Outras dúvidas',
  },
];

// ============================================================
// PERGUNTAS E RESPOSTAS DO CHATBOT
// ============================================================
export const chatResponses = {
  // --- BARBEIRO / DONO ---
  owner: [
    {
      id: 'owner-register',
      question: 'Como registar a minha barbearia?',
      answer: `Para registar a sua barbearia:\n\n1. Crie uma conta selecionando "Sou Dono de Barbearia" no registo\n2. Após o login, aceda ao seu painel em "Minha Barbearia"\n3. Preencha os dados: nome, endereço, telefone, horário de funcionamento\n4. Adicione fotos da sua barbearia\n5. Clique em "Salvar" para publicar\n\nA sua barbearia ficará visível para todos os clientes na plataforma!`,
      keywords: ['registar', 'registrar', 'criar', 'barbearia', 'cadastrar', 'nova'],
    },
    {
      id: 'owner-slots',
      question: 'Como criar horários disponíveis?',
      answer: `Para criar horários de atendimento:\n\n1. Acesse a página da sua barbearia\n2. Na seção "Gestão de Horários", clique em "Adicionar Horário"\n3. Selecione a data e o horário desejado\n4. Defina o serviço e o preço\n5. Clique em "Criar Slot"\n\n💡 Dica: Use "Adicionar em Massa" para criar vários horários de uma vez, selecionando um intervalo de datas e horários!`,
      keywords: ['horário', 'horarios', 'slot', 'criar', 'adicionar', 'disponível', 'agenda'],
      phrases: ['criar horário', 'adicionar horário', 'disponibilizar horário', 'colocar um horário', 'abrir horário', 'criar slot'],
      negativeKeywords: ['como cliente', 'quero agendar', 'quero marcar', 'entrar em uma barbearia'],
    },
    {
      id: 'owner-bulk-slots',
      question: 'Como adicionar horários em massa?',
      answer: `A funcionalidade de "Horários em Massa" permite criar vários slots de uma vez:\n\n1. Na página da sua barbearia, clique em "Adicionar em Massa"\n2. Selecione as datas (pode escolher um intervalo)\n3. Defina o horário de início e fim\n4. Escolha o intervalo entre cada atendimento (30min, 1h, etc.)\n5. Selecione os serviços disponíveis\n6. Confirme a criação\n\nIsso criará automaticamente todos os horários no período selecionado!`,
      keywords: ['massa', 'bulk', 'vários', 'múltiplos', 'lote', 'automatico'],
    },
    {
      id: 'owner-accept',
      question: 'Como aceitar/rejeitar agendamentos?',
      answer: `Para gerir os pedidos de agendamento:\n\n1. Acesse a página da sua barbearia\n2. Veja a lista de agendamentos pendentes\n3. Para cada pedido, terá as opções:\n   • ✅ **Aceitar** - Confirma o agendamento\n   • ❌ **Rejeitar** - Recusa o pedido\n4. O cliente receberá uma notificação automática\n\n⚡ Recomendamos responder rapidamente para manter uma boa reputação!`,
      keywords: ['aceitar', 'aceito', 'rejeitar', 'pedido', 'agendamento', 'confirmar', 'aprovar', 'recusar'],
      phrases: ['aceitar pedido', 'aceito o pedido', 'confirmar agendamento', 'rejeitar agendamento'],
    },
    {
      id: 'owner-services',
      question: 'Como adicionar serviços e preços?',
      answer: `Para configurar os seus serviços:\n\n1. Vá em "Minha Barbearia" > "Editar"\n2. Na seção "Serviços", clique em "Adicionar Serviço"\n3. Preencha:\n   • Nome do serviço (ex: Corte Clássico)\n   • Preço\n   • Duração estimada\n   • Descrição (opcional)\n4. Salve as alterações\n\nOs serviços aparecerão para os clientes ao agendar!`,
      keywords: ['serviço', 'serviços', 'preço', 'preços', 'adicionar', 'editar', 'valor'],
    },
    {
      id: 'owner-analytics',
      question: 'Como ver relatórios e estatísticas?',
      answer: `Para acessar as análises da sua barbearia:\n\n1. No menu principal, clique em "Analytics"\n2. Verá dashboards com:\n   • 📊 Total de agendamentos\n   • 💰 Receita estimada\n   • 📈 Evolução ao longo do tempo\n   • ⭐ Avaliações dos clientes\n   • 👥 Clientes mais frequentes\n\nUse esses dados para otimizar seus horários e serviços!`,
      keywords: ['relatório', 'estatística', 'analytics', 'dados', 'receita', 'dashboard', 'gráfico'],
    },
    {
      id: 'owner-edit',
      question: 'Como editar informações da barbearia?',
      answer: `Para editar a sua barbearia:\n\n1. Acesse "Minha Barbearia"\n2. Clique no botão "Editar Barbearia"\n3. Pode alterar:\n   • Nome e descrição\n   • Endereço\n   • Telefone e contacto\n   • Horário de funcionamento\n   • Fotos\n   • Serviços\n4. Clique em "Salvar" para aplicar as mudanças`,
      keywords: ['editar', 'alterar', 'mudar', 'atualizar', 'informação', 'dados', 'foto'],
    },
    {
      id: 'owner-cancel',
      question: 'Como cancelar um agendamento como dono?',
      answer: `Para cancelar um agendamento:\n\n1. Acesse a página da sua barbearia\n2. Encontre o agendamento na lista\n3. Clique em "Cancelar"\n4. Confirme o cancelamento\n\n⚠️ O cliente será notificado automaticamente sobre o cancelamento. Se possível, cancele com antecedência para não prejudicar o cliente.`,
      keywords: ['cancelar', 'cancelamento', 'desmarcar', 'remover'],
    },
  ],

  // --- CLIENTE ---
  client: [
    {
      id: 'client-book',
      question: 'Como agendar um corte?',
      answer: `Para agendar um corte de cabelo:\n\n1. Na página inicial, procure a barbearia desejada\n2. Clique na barbearia para ver os detalhes\n3. Selecione um horário disponível (em verde)\n4. Escolha o serviço desejado\n5. Confirme o agendamento\n\nReceberá uma notificação quando o barbeiro confirmar! 💈`,
      keywords: ['agendar', 'marcar', 'corte', 'cabelo', 'reservar', 'booking'],
      phrases: ['agendar horário', 'marcar horário', 'reservar atendimento', 'entrar em uma barbearia', 'agendar como cliente'],
      negativeKeywords: ['criar horário', 'adicionar horário', 'disponibilizar horário', 'criar slot'],
    },
    {
      id: 'client-cancel',
      question: 'Como cancelar um agendamento?',
      answer: `Para cancelar um agendamento:\n\n1. Vá em "Meus Agendamentos" no menu\n2. Encontre o agendamento que deseja cancelar\n3. Clique em "Cancelar"\n4. Confirme o cancelamento\n\n⚠️ Atenção: Cancele com antecedência. Cancelamentos muito próximos do horário agendado podem afetar a sua reputação na plataforma.`,
      keywords: ['cancelar', 'desmarcar', 'anular', 'cancelamento'],
    },
    {
      id: 'client-view',
      question: 'Como ver meus agendamentos?',
      answer: `Para ver os seus agendamentos:\n\n1. Faça login na sua conta\n2. Clique em "Meus Agendamentos" no menu\n3. Verá uma lista com:\n   • 📅 Agendamentos futuros\n   • ✅ Agendamentos confirmados\n   • ⏳ Agendamentos pendentes\n   • 📜 Histórico de agendamentos passados\n\nPode filtrar por status para encontrar mais facilmente!`,
      keywords: ['ver', 'visualizar', 'meus', 'agendamentos', 'consultar', 'lista'],
    },
    {
      id: 'client-review',
      question: 'Como avaliar uma barbearia?',
      answer: `Para deixar uma avaliação:\n\n1. Após o atendimento ser concluído, acesse "Meus Agendamentos"\n2. No agendamento finalizado, clique em "Avaliar"\n3. Dê uma nota de 1 a 5 estrelas ⭐\n4. Escreva um comentário (opcional)\n5. Envie a avaliação\n\nA sua avaliação ajuda outros clientes a escolherem e motiva o barbeiro!`,
      keywords: ['avaliar', 'avaliação', 'estrela', 'nota', 'comentário', 'review', 'feedback'],
    },
    {
      id: 'client-search',
      question: 'Como encontrar barbearias?',
      answer: `Para encontrar barbearias:\n\n1. Na página inicial, verá a lista de barbearias disponíveis\n2. Use a barra de pesquisa para filtrar por nome ou localização\n3. Veja as avaliações e fotos de cada barbearia\n4. Clique numa barbearia para ver detalhes, serviços e horários\n\n💡 Dica: As barbearias com melhor avaliação aparecem primeiro!`,
      keywords: ['encontrar', 'procurar', 'pesquisar', 'buscar', 'barbearia', 'localização'],
    },
    {
      id: 'client-waitlist',
      question: 'Como funciona a lista de espera?',
      answer: `A lista de espera permite que seja notificado quando vagar um horário:\n\n1. Se não houver horário disponível na data desejada\n2. Clique em "Entrar na Lista de Espera"\n3. Preencha as suas preferências de horário\n4. Quando um horário ficar disponível, receberá uma notificação\n5. Terá prioridade para agendar!\n\nIsso ajuda quando a barbearia está com muita procura.`,
      keywords: ['espera', 'lista', 'waitlist', 'notificação', 'disponível', 'fila'],
    },
  ],

  // --- CONTA E ACESSO ---
  account: [
    {
      id: 'account-register',
      question: 'Como criar uma conta?',
      answer: `Para criar uma conta:\n\n1. Clique em "Cadastrar" no canto superior direito\n2. Escolha o tipo de conta:\n   • 👤 **Cliente** - Para agendar cortes\n   • 💈 **Dono de Barbearia** - Para gerir a sua barbearia\n3. Preencha os dados: nome, email e senha\n4. Confirme o registo\n\nPronto! Já pode utilizar a plataforma.`,
      keywords: ['criar', 'conta', 'registo', 'cadastrar', 'registar', 'inscrever'],
    },
    {
      id: 'account-login',
      question: 'Não consigo fazer login',
      answer: `Se está com problemas para fazer login:\n\n1. **Verifique o email e senha** - Certifique-se de que estão corretos\n2. **Esqueceu a senha?** - Clique em "Esqueci minha senha" na página de login\n3. **Conta não encontrada?** - Verifique se já tem conta registada\n4. **Erro persistente?** - Limpe o cache do navegador e tente novamente\n\nSe o problema persistir, entre em contacto pelo formulário de Contacto.`,
      keywords: ['login', 'entrar', 'aceder', 'senha', 'password', 'problema', 'erro', 'não consigo'],
    },
    {
      id: 'account-password',
      question: 'Como recuperar a minha senha?',
      answer: `Para recuperar a senha:\n\n1. Vá à página de login\n2. Clique em "Esqueci minha senha"\n3. Introduza o seu email registado\n4. Receberá um email com um link de redefinição\n5. Clique no link e defina uma nova senha\n\n📧 Se não receber o email, verifique a pasta de spam.`,
      keywords: ['senha', 'password', 'recuperar', 'esqueci', 'redefinir', 'alterar'],
    },
    {
      id: 'account-profile',
      question: 'Como editar o meu perfil?',
      answer: `Para editar o seu perfil:\n\n1. Clique no seu nome no canto superior direito\n2. Selecione "Perfil"\n3. Pode alterar:\n   • Nome\n   • Email\n   • Telefone\n   • Foto de perfil\n4. Clique em "Salvar" para confirmar as alterações`,
      keywords: ['perfil', 'editar', 'alterar', 'foto', 'nome', 'email', 'dados'],
    },
  ],

  // --- GERAL ---
  general: [
    {
      id: 'general-what',
      question: 'O que é o Barberize?',
      answer: `O **Barberize** é uma plataforma de agendamento online para barbearias! 💈\n\n• **Para Clientes**: Encontre barbearias, veja horários disponíveis e agende com facilidade\n• **Para Barbeiros**: Gira os seus horários, aceite agendamentos e acompanhe as estatísticas\n\nTudo de forma rápida, simples e organizada!`,
      keywords: ['barberize', 'plataforma', 'aplicação', 'app', 'que é', 'sobre', 'funciona'],
    },
    {
      id: 'general-free',
      question: 'O Barberize é gratuito?',
      answer: `Sim! O Barberize é **gratuito** para utilizar:\n\n• ✅ Criar conta é grátis\n• ✅ Agendar cortes é grátis\n• ✅ Registar barbearia é grátis\n\nO pagamento dos serviços é feito diretamente entre o cliente e o barbeiro.`,
      keywords: ['grátis', 'gratuito', 'free', 'preço', 'custo', 'pagar', 'cobrar'],
    },
    {
      id: 'general-contact',
      question: 'Como entrar em contacto com o suporte?',
      answer: `Para falar connosco:\n\n1. Acesse a página de "Contato" no menu\n2. Preencha o formulário com:\n   • Seu nome\n   • Email\n   • Mensagem\n3. Envie e responderemos o mais breve possível!\n\nAlternativamente, pode usar este chatbot para respostas rápidas. 🤖`,
      keywords: ['contacto', 'contato', 'suporte', 'ajuda', 'falar', 'email', 'mensagem'],
    },
    {
      id: 'general-notifications',
      question: 'Como funcionam as notificações?',
      answer: `O sistema de notificações mantém-no informado:\n\n• 🔔 **Novo agendamento** - Quando alguém agenda consigo\n• ✅ **Confirmação** - Quando o barbeiro aceita\n• ❌ **Cancelamento** - Se um agendamento for cancelado\n• ⏰ **Lembrete** - Antes do horário agendado\n\nAs notificações aparecem no sino 🔔 no canto superior. Pode ver todas na página de Notificações.`,
      keywords: ['notificação', 'notificações', 'alerta', 'aviso', 'sino', 'lembrete'],
    },
  ],
};

// ============================================================
// TUTORIAIS PASSO A PASSO
// ============================================================
export const tutorials = [
  // --- TUTORIAIS PARA DONOS ---
  {
    id: 'tut-register-barbershop',
    title: 'Registar a Sua Barbearia',
    description: 'Aprenda a configurar a sua barbearia na plataforma do zero',
    category: 'owner',
    icon: '💈',
    estimatedTime: '5 min',
    steps: [
      {
        title: 'Crie a sua conta',
        description: 'Acesse a página de Cadastro e selecione "Sou Dono de Barbearia". Preencha os seus dados pessoais e crie uma senha forte.',
        tip: 'Use um email profissional para transmitir mais confiança aos clientes.',
      },
      {
        title: 'Faça login',
        description: 'Após o registo, faça login com as suas credenciais. Será direcionado para o painel de dono de barbearia.',
        tip: null,
      },
      {
        title: 'Acesse "Minha Barbearia"',
        description: 'No menu principal, clique em "Minha Barbearia". Aqui é onde irá gerir tudo sobre o seu negócio.',
        tip: null,
      },
      {
        title: 'Preencha as informações',
        description: 'Adicione o nome da barbearia, endereço completo, telefone de contacto, horário de funcionamento e uma descrição atrativa.',
        tip: 'Uma boa descrição e fotos atraem mais clientes. Capriche!',
      },
      {
        title: 'Adicione fotos',
        description: 'Faça upload de fotos da sua barbearia. Mostre o ambiente, os cortes realizados e a equipa.',
        tip: 'Fotos com boa iluminação fazem toda a diferença!',
      },
      {
        title: 'Publique!',
        description: 'Clique em "Salvar" para publicar. A sua barbearia já estará visível para todos os clientes da plataforma.',
        tip: null,
      },
    ],
  },
  {
    id: 'tut-manage-slots',
    title: 'Gerir Horários de Atendimento',
    description: 'Como criar e organizar os seus horários disponíveis para agendamento',
    category: 'owner',
    icon: '📅',
    estimatedTime: '3 min',
    steps: [
      {
        title: 'Acesse a página da barbearia',
        description: 'Vá em "Minha Barbearia" para acessar o painel de gestão.',
        tip: null,
      },
      {
        title: 'Encontre a seção de horários',
        description: 'Role até a seção "Gestão de Horários" onde poderá ver os slots existentes e criar novos.',
        tip: null,
      },
      {
        title: 'Adicione um horário individual',
        description: 'Clique em "Adicionar Horário", selecione data, hora, serviço e preço. Confirme para criar o slot.',
        tip: 'Mantenha os preços atualizados para evitar mal-entendidos.',
      },
      {
        title: 'Ou use horários em massa',
        description: 'Para ganhar tempo, clique em "Adicionar em Massa". Defina um período (ex: próxima semana), horário de início/fim e intervalo entre slots.',
        tip: 'Ideal para configurar a semana inteira de uma vez!',
      },
      {
        title: 'Gerir horários existentes',
        description: 'Pode visualizar, editar ou remover slots já criados. Slots agendados mostram o nome do cliente.',
        tip: 'Remova slots vazios de datas passadas para manter tudo organizado.',
      },
    ],
  },
  {
    id: 'tut-handle-appointments',
    title: 'Gerir Pedidos de Agendamento',
    description: 'Como aceitar, rejeitar e acompanhar os agendamentos dos seus clientes',
    category: 'owner',
    icon: '✅',
    estimatedTime: '3 min',
    steps: [
      {
        title: 'Veja os pedidos pendentes',
        description: 'Na página da barbearia, os novos pedidos aparecem na seção de agendamentos com status "Pendente".',
        tip: 'Responda rápido! Clientes preferem barbearias que confirmam depressa.',
      },
      {
        title: 'Aceite um agendamento',
        description: 'Clique no botão ✅ "Aceitar" para confirmar o agendamento. O cliente será notificado automaticamente.',
        tip: null,
      },
      {
        title: 'Rejeite se necessário',
        description: 'Se não puder atender, clique em ❌ "Rejeitar". O cliente será informado e poderá tentar outro horário.',
        tip: 'Se possível, sugira um horário alternativo antes de rejeitar.',
      },
      {
        title: 'Acompanhe os agendamentos',
        description: 'Veja o calendário com todos os agendamentos confirmados. Azul = confirmado, amarelo = pendente, cinza = passado.',
        tip: null,
      },
      {
        title: 'Cancele se necessário',
        description: 'Em caso de imprevisto, pode cancelar um agendamento confirmado. O cliente receberá notificação.',
        tip: 'Cancele com a maior antecedência possível por respeito ao cliente.',
      },
    ],
  },
  {
    id: 'tut-analytics',
    title: 'Acompanhar Estatísticas',
    description: 'Como usar o painel de análises para melhorar o seu negócio',
    category: 'owner',
    icon: '📊',
    estimatedTime: '2 min',
    steps: [
      {
        title: 'Acesse a página Analytics',
        description: 'No menu principal, clique em "Analytics" para abrir o painel de estatísticas.',
        tip: null,
      },
      {
        title: 'Veja os indicadores principais',
        description: 'No topo, encontrará cards com: total de agendamentos, receita estimada, avaliação média e taxa de ocupação.',
        tip: null,
      },
      {
        title: 'Analise os gráficos',
        description: 'Os gráficos mostram a evolução ao longo do tempo: agendamentos por dia/semana, horários mais populares e serviços mais pedidos.',
        tip: 'Use essas informações para ajustar seus horários de maior procura.',
      },
      {
        title: 'Otimize o seu negócio',
        description: 'Com base nos dados, identifique os melhores horários, serviços mais rentáveis e oportunidades de melhoria.',
        tip: 'Abra mais slots nos horários de pico para maximizar o faturamento!',
      },
    ],
  },

  // --- TUTORIAIS PARA CLIENTES ---
  {
    id: 'tut-first-booking',
    title: 'O Seu Primeiro Agendamento',
    description: 'Guia completo para agendar o seu primeiro corte na plataforma',
    category: 'client',
    icon: '✂️',
    estimatedTime: '3 min',
    steps: [
      {
        title: 'Crie a sua conta',
        description: 'Clique em "Cadastrar" e preencha os seus dados. Selecione "Sou Cliente" como tipo de conta.',
        tip: null,
      },
      {
        title: 'Explore as barbearias',
        description: 'Na página inicial, verá a lista de barbearias disponíveis. Use a pesquisa para filtrar por nome ou localização.',
        tip: 'Veja as avaliações e fotos para escolher a melhor opção!',
      },
      {
        title: 'Escolha uma barbearia',
        description: 'Clique na barbearia desejada para ver os detalhes, serviços oferecidos, preços e horários disponíveis.',
        tip: null,
      },
      {
        title: 'Selecione um horário',
        description: 'Na seção de horários, os slots em verde estão disponíveis. Clique num para iniciar o agendamento.',
        tip: 'Horários pela manhã geralmente têm mais disponibilidade.',
      },
      {
        title: 'Confirme o agendamento',
        description: 'Revise os detalhes (data, hora, serviço, preço) e confirme. O pedido será enviado ao barbeiro.',
        tip: null,
      },
      {
        title: 'Aguarde a confirmação',
        description: 'O barbeiro irá aceitar ou sugerir alternativas. Receberá uma notificação com a resposta.',
        tip: 'Ative as notificações para não perder atualizações!',
      },
    ],
  },
  {
    id: 'tut-manage-bookings',
    title: 'Gerir os Seus Agendamentos',
    description: 'Como ver, cancelar e acompanhar os seus agendamentos',
    category: 'client',
    icon: '📋',
    estimatedTime: '2 min',
    steps: [
      {
        title: 'Acesse "Meus Agendamentos"',
        description: 'No menu principal, clique em "Meus Agendamentos" para ver a lista completa.',
        tip: null,
      },
      {
        title: 'Veja os diferentes status',
        description: 'Os agendamentos possuem status: ⏳ Pendente (aguardando confirmação), ✅ Confirmado (aceite pelo barbeiro), ❌ Cancelado, ✔️ Concluído.',
        tip: null,
      },
      {
        title: 'Cancele se necessário',
        description: 'Para cancelar, encontre o agendamento e clique em "Cancelar". Confirme a operação.',
        tip: 'Cancele com pelo menos 2 horas de antecedência quando possível.',
      },
      {
        title: 'Avalie após o atendimento',
        description: 'Depois do corte, avalie a experiência com estrelas e um comentário. Isso ajuda outros clientes!',
        tip: null,
      },
    ],
  },

  // --- TUTORIAIS GERAIS ---
  {
    id: 'tut-notifications',
    title: 'Sistema de Notificações',
    description: 'Entenda como funcionam as notificações do Barberize',
    category: 'general',
    icon: '🔔',
    estimatedTime: '1 min',
    steps: [
      {
        title: 'Onde ver as notificações',
        description: 'Clique no ícone de sino 🔔 no canto superior direito do menu para ver as notificações recentes.',
        tip: null,
      },
      {
        title: 'Tipos de notificação',
        description: 'Receberá notificações para: novos agendamentos, confirmações, cancelamentos, lembretes e avaliações.',
        tip: null,
      },
      {
        title: 'Página de Notificações',
        description: 'Para ver o histórico completo, acesse a página "Notificações" onde pode filtrar e gerir todas as suas notificações.',
        tip: null,
      },
    ],
  },
];

// ============================================================
// MENSAGEM PADRÃO QUANDO NÃO ENCONTRA RESPOSTA
// ============================================================
export const fallbackResponse = {
  message: `Desculpe, não encontrei uma resposta específica para a sua pergunta. 😕\n\nPode tentar:\n• Reformular a pergunta com outras palavras\n• Escolher uma das categorias acima\n• Contactar o suporte através da página de Contato\n\nEstou aqui para ajudar! 🤖`,
};

// ============================================================
// MENSAGEM DE BOAS-VINDAS
// ============================================================
export const welcomeMessage = {
  message: `Olá! 👋 Sou o assistente virtual do **Barberize**!\n\nComo posso ajudá-lo hoje? Escolha uma categoria abaixo ou escreva a sua dúvida:`,
};
